  document.addEventListener('DOMContentLoaded', function () {
    const originalSelect = document.querySelector('[data-js-product-variant-container="select"]');
    const copySelect = document.getElementById('product-variant-copy');

    if (!originalSelect || !copySelect) return;

    // Copy-Select komplett leeren (keine leere Option behalten)
    copySelect.innerHTML = '';

    // Optionen aus dem Original-Select ins Copy-Select kopieren
    Array.from(originalSelect.options).forEach(function (opt) {
      const newOpt = opt.cloneNode(true);
      copySelect.appendChild(newOpt);
    });

    // Anfangswert synchronisieren
    copySelect.value = originalSelect.value;

    // Wenn im Copy-Select gewechselt wird → Original umschalten
    copySelect.addEventListener('change', function () {
      const value = copySelect.value;
      originalSelect.value = value;

      // Shopify-Change-Event triggern
      const evt = new Event('change', { bubbles: true });
      originalSelect.dispatchEvent(evt);
    });

    // Wenn das Original sich ändert → Copy-Select nachziehen
    originalSelect.addEventListener('change', function () {
      copySelect.value = originalSelect.value;
    });
  });
